import './bootstrap';
import '../css/app.css';
import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import axios from 'axios';
import { createI18n } from 'vue-i18n'

import en from './locales/en.json'
import fr from './locales/fr.json'
import ar from './locales/ar.json'

const defaultLocale = window.appLocale || 'en'
axios.defaults.headers.common['Accept-Language'] = defaultLocale;

const app = createApp(App);

const preset = definePreset(Aura, {
    semantic: {
        colorScheme: {
            light: {
                primary: {
                    color: '{emerald.700}',
                    hoverColor: '{emerald.800}',
                    activeColor: '{emerald.900}',
                    textColor: '{neutral.0}',
                    hoverTextColor: '{neutral.0}',
                    activeTextColor: '{neutral.0}',
                },
            }
        },
    },
});

app.use(PrimeVue, {
    theme: {
        preset: preset,
        options: {
            ripple: true,
            // prefix: 'p',
            darkModeSelector: 'light',
        },
    },
});

const i18n = createI18n({
    legacy: false, // use Composition API
    locale: defaultLocale,
    fallbackLocale: 'en',
    messages: { en, fr, ar }
})

app.use(router);
app.use(i18n);

app.mount("#app");
